// extracted by mini-css-extract-plugin
export default {"container":"SlideLoader__container___gvJE6","inner":"SlideLoader__inner___VthsQ"};